import { styled, css } from "styled-components";

interface PageSectionContainerProps {
    $gap?: number;
    $paddTop?: number;
    $justify?: string;
}

export const PageSectionContainer = styled.div<PageSectionContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    ${({ theme, $gap, $paddTop, $justify }) => css`
        color: ${theme.colors.text};
        gap: ${$gap ? `${$gap}rem` : "0"};
        padding-top: ${$paddTop ? `${$paddTop}rem` : "0"};
        transition: ${theme.animationTime.short}s all ease;
        justify-content: ${$justify ? $justify : "center"};
        @media screen and (max-width: ${theme.breakpoint}px) {
            width: 90%;
        }
    `}
`;
